import type { InstrumentPanel as InstrumentPanelT } from 'lib-analytics-types';
import { AnalyticsMenu, type AnalyticsMenuActions } from 'lib-analytics-ui';
import { PropsWithChildren } from 'lib-shared-types-utils';

import { InstrumentPanelTitle } from './components/title/instrumentPanelTitle';
import styles from './instrumentPanel.module.scss';

export type InstrumentPanelProps = {
  /** The instrument panel. */
  panel: InstrumentPanelT;
  /** The list of menu actions for the instrument panel. */
  actions?: AnalyticsMenuActions;
  /** Whether to show the panel header. */
  showHeader?: boolean;
  /** The customheight of the panel. */
  height?: number;
} & PropsWithChildren;

export const InstrumentPanel = ({
  children,
  panel,
  actions = [],
  showHeader = true,
  height,
}: InstrumentPanelProps): JSX.Element => {
  return (
    <div
      className={styles.panel}
      data-analytics-panel={panel.id}
      style={{ minHeight: height, maxHeight: height }}
    >
      {showHeader && (
        <div className={styles.header}>
          <InstrumentPanelTitle panel={panel} />

          <AnalyticsMenu
            actions={actions}
            direction="left"
            dropdownButtonProps={{
              'data-analytics-panel-menu': true,
            }}
          />
        </div>
      )}

      <div className={styles.content}>{children}</div>
    </div>
  );
};
